import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import CardWrapper from "../../CardWrapper";
import Card from "../../Card";
import { getCancerGeneCensusData } from "../../../../state/selectors/CGC.selectors";
import { CancerGeneCensusType } from "../../../componentTypes/CancerGeneCensusType";
import { TIER_TO_PATHOGENICITY } from "./helpers";
import { getPathogenicityColorByAllNames } from "../../../../common/helpers/Constant";
import tailwindColors from "../../../../../../tailwind.colors";

const GeneCGCCard = ({ card, cancerGeneCensusData }) => {
  const isDisabled = !Object.keys(cancerGeneCensusData || {}).length;
  const { tier, somatic, germline } = cancerGeneCensusData;
  const color = tier
    ? getPathogenicityColorByAllNames(TIER_TO_PATHOGENICITY[tier])
    : tailwindColors.gray[300];

  return (
    <CardWrapper {...card} isDisabled={isDisabled} color={color}>
      <>
        <div className="tw-flex">
          <div>
            {tier ? (
              <b
                data-testid="cancer-gene-census-tier"
                className="tw-mr-2"
                style={{ color }}
              >
                {TIER_TO_PATHOGENICITY[tier]}
              </b>
            ) : null}
          </div>
        </div>
        <div className="tw-flex">
          <span>
            {`Somatic: `}
            <b data-testid="cancer-gene-census-somatic" className="tw-mr-2">
              {somatic ? "True" : "False"}
            </b>
          </span>
          <span>
            {`Germline: `}
            <b data-testid="cancer-gene-census-gemline" className="tw-mr-2">
              {germline ? "True" : "False"}
            </b>
          </span>
        </div>
      </>
    </CardWrapper>
  );
};

GeneCGCCard.propTypes = {
  card: PropTypes.instanceOf(Card).isRequired,
  cancerGeneCensusData: CancerGeneCensusType,
};

GeneCGCCard.defaultProps = {
  cancerGeneCensusData: {},
};

const mapStateToProps = (state) => ({
  cancerGeneCensusData: getCancerGeneCensusData(state),
});

export default connect(mapStateToProps, {})(GeneCGCCard);
